import React from "react";
import { Modal } from "react-bootstrap";

const CHANNELS = [
  {
    name: "WhatsApp Channel",
    handle: "@WaqarZakaTrades",
    href: "https://whatsapp.com/channel/0029Vb6Z5GGEQIajENhVj20H",
    icon: "fa-brands fa-whatsapp",
    bg: "linear-gradient(135deg, #25D366 0%, #128C7E 100%)",
    shadow: "0 8px 24px rgba(37,211,102,0.35)",
  },
  {
    name: "Instagram Broadcast",
    handle: "@WaqarZaka",
    href: "https://www.instagram.com/channel/AbbEEsvUoFTOHaPf",
    icon: "fa-brands fa-instagram",
    bg: "linear-gradient(135deg, #F58529 0%, #DD2A7B 50%, #8134AF 100%)",
    shadow: "0 8px 24px rgba(221,42,123,0.35)",
  },
  {
    name: "Messenger Channel",
    handle: "@WaqarZaka",
    href: "https://www.messenger.com/channel/waqarzaka",
    icon: "fa-brands fa-facebook-messenger",
    bg: "linear-gradient(135deg, #0099FF 0%, #A033FF 100%)",
    shadow: "0 8px 24px rgba(0,153,255,0.35)",
  },
];

export const JoinBroadcastModal = ({ show, onHide }) => {
  return (
    <Modal size="md" show={show} onHide={onHide} centered>
      <Modal.Body style={{ padding: 0, borderRadius: 20, overflow: "hidden" }}>
        <div style={s.wrap}>
          {/* Close */}
          <button style={s.close} onClick={onHide} aria-label="Close">
            <i className="fa-solid fa-xmark" />
          </button>

          {/* Header banner */}
          <div style={s.banner}>
            <div style={s.bannerOrb1} />
            <div style={s.bannerOrb2} />
            <div style={s.bannerIcons}>
              {CHANNELS.map((ch, i) => (
                <div
                  key={i}
                  style={{
                    ...s.bannerIcon,
                    background: ch.bg,
                    zIndex: 3 - i,
                    marginLeft: i === 0 ? 0 : -8,
                  }}
                >
                  <i className={ch.icon} style={{ fontSize: 28, color: "#fff" }} />
                </div>
              ))}
            </div>
            <div style={s.bannerLabel}>
              <i className="fa-solid fa-satellite-dish" style={{ marginRight: 7, fontSize: 13 }} />
              BROADCAST CHANNELS
            </div>
            <div style={s.bannerOverlay} />
          </div>

          {/* Content */}
          <div style={s.content}>
            <h2 style={s.title}>Stay Ahead of the Market</h2>
            <p style={s.sub}>
              Follow Waqar Zaka's live trade alerts, stock insights &amp; crypto
              calls — directly on your favourite platform.
            </p>

            {/* Platform cards */}
            <div style={s.cards}>
              {CHANNELS.map((ch) => (
                <a
                  key={ch.href}
                  href={ch.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={s.card}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-3px)";
                    e.currentTarget.style.boxShadow = ch.shadow;
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.08)";
                  }}
                >
                  <div style={{ ...s.iconWrap, background: ch.bg }}>
                    <i className={ch.icon} style={s.platformIcon} />
                  </div>
                  <div style={s.cardInfo}>
                    <span style={s.cardName}>{ch.name}</span>
                    <span style={s.cardHandle}>{ch.handle}</span>
                  </div>
                  <div style={{ ...s.joinBtn, background: ch.bg }}>
                    Join <i className="fa-solid fa-arrow-right" style={{ marginLeft: 6, fontSize: 11 }} />
                  </div>
                </a>
              ))}
            </div>

            <p style={s.footer}>
              Get exclusive trade alerts before they go public 🔔
            </p>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

const s = {
  wrap: {
    background: "#fff",
    borderRadius: 20,
    overflow: "hidden",
    position: "relative",
  },
  close: {
    position: "absolute",
    top: 14,
    right: 14,
    zIndex: 10,
    width: 32,
    height: 32,
    borderRadius: "50%",
    background: "rgba(0,0,0,0.35)",
    border: "none",
    color: "#fff",
    fontSize: 14,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
  },
  banner: {
    position: "relative",
    height: 160,
    background: "linear-gradient(135deg, #0f0c29 0%, #302b63 50%, #24243e 100%)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: 14,
    overflow: "hidden",
  },
  bannerOrb1: {
    position: "absolute",
    width: 200,
    height: 200,
    borderRadius: "50%",
    background: "radial-gradient(circle, rgba(124,58,237,0.4) 0%, transparent 70%)",
    top: -60,
    left: -40,
  },
  bannerOrb2: {
    position: "absolute",
    width: 180,
    height: 180,
    borderRadius: "50%",
    background: "radial-gradient(circle, rgba(0,153,255,0.3) 0%, transparent 70%)",
    bottom: -60,
    right: -30,
  },
  bannerIcons: {
    display: "flex",
    alignItems: "center",
    position: "relative",
    zIndex: 2,
  },
  bannerIcon: {
    width: 60,
    height: 60,
    borderRadius: 16,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "3px solid rgba(255,255,255,0.15)",
    boxShadow: "0 4px 16px rgba(0,0,0,0.4)",
  },
  bannerLabel: {
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: 2,
    color: "rgba(255,255,255,0.7)",
    textTransform: "uppercase",
    position: "relative",
    zIndex: 2,
  },
  bannerOverlay: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    height: 40,
    background: "linear-gradient(to bottom, transparent, rgba(255,255,255,1))",
  },
  content: {
    padding: "16px 28px 28px",
  },
  title: {
    fontSize: 22,
    fontWeight: 800,
    color: "#0f0f0f",
    margin: "0 0 8px",
    lineHeight: 1.2,
  },
  sub: {
    fontSize: 13,
    color: "#6b7280",
    lineHeight: 1.6,
    margin: "0 0 20px",
  },
  cards: {
    display: "flex",
    flexDirection: "column",
    gap: 12,
  },
  card: {
    display: "flex",
    alignItems: "center",
    gap: 14,
    padding: "12px 14px",
    borderRadius: 14,
    border: "1px solid #f0f0f0",
    background: "#fafafa",
    textDecoration: "none",
    transition: "transform 0.2s, box-shadow 0.2s",
    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
    cursor: "pointer",
  },
  iconWrap: {
    width: 46,
    height: 46,
    borderRadius: 12,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  platformIcon: {
    fontSize: 22,
    color: "#fff",
  },
  cardInfo: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    gap: 2,
  },
  cardName: {
    fontSize: 14,
    fontWeight: 700,
    color: "#111",
  },
  cardHandle: {
    fontSize: 12,
    color: "#9ca3af",
  },
  joinBtn: {
    fontSize: 12,
    fontWeight: 700,
    color: "#fff",
    padding: "6px 14px",
    borderRadius: 20,
    display: "flex",
    alignItems: "center",
    whiteSpace: "nowrap",
    flexShrink: 0,
  },
  footer: {
    textAlign: "center",
    fontSize: 12,
    color: "#9ca3af",
    marginTop: 18,
    marginBottom: 0,
  },
};
